import React, { useContext } from 'react';
import { Button, Popconfirm, Table, Tag, Image, Tooltip } from 'antd';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
import {
  DeleteFilled,
  RollbackOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
dayjs.extend(calendar)

const Submodel: React.FC = observer(() => {
  const {
    RecycleStore: {
      state: {
        data: { submodels, total, offset, limit, search },
        ui: { recyclerLoading }
      },
      getAllDeletedItems,
      deleteItemForever,
      restoreItems
    }
  } = useContext(rootContext);

  return (
    <Table
      className="Table_block_main"
      columns={[
        {
          dataIndex: 'submodel',
          title: 'Name',
          align: 'center',
          render: (name: string) => {
            return <p>{name}</p>;
          }
        },
        {
          title: 'Image',
          dataIndex: 'url',
          key: 'url',
          align: 'center',
          width: 10,
          render: (value: string) => (
            <div className="tableImage">
              <Image src={value} />
            </div>
          )
        },
        {
          title: 'Trims',
          dataIndex: 'trim',
          align: 'left',
          render: (value, row) => {
            return !value ? (
              <Tag>No Trims</Tag>
            ) : (
              row?.trim?.map((item: { name: string; image: string }) => (
                <div className="subModelContainer">
                  <Tag>{item.name}</Tag>
                  <div className="tableImage">
                    <Image src={item.image} alt={item.name} />
                  </div>
                </div>
              ))
            );
          }
        },
        {
          title: 'Regions',
          dataIndex: 'region',
          width: '20%',
          align: 'center',
          render: (value: any) => {
            return !value?.length ? (
              <Button>No Region</Button>
            ) : (
              value?.map((item: { name: string }) => <Tag>{item.name}</Tag>)
            );
          }
        },
        {
          title: 'Start Year',
          dataIndex: 'startMakingYear',
          align: 'center',
          render: (value: string) => <p>{value ? value : '----'}</p>
        },
        {
          title: 'End Year',
          dataIndex: 'endMakingYear',
          align: 'center',
          render: (value: string) => <p>{value ? value : '----'}</p>
        },
        {
          title: 'Deleted Time',
          align: 'center',
          dataIndex: 'deletedAt',
          render: (value: string) => dayjs(value).calendar()
        },
        {
          title: 'Action',
          align: 'center',
          width: 10,
          render: (_: any, record: any) => (
            <div className="actionButtons">
              <Tooltip title="Restore Submodel">
                <Button
                  type="default"
                  className="editButton"
                  onClick={() => {
                    restoreItems({ id: record.id, type: 'SUBMODEL' });
                  }}
                >
                  <RollbackOutlined />
                </Button>
              </Tooltip>
              <Popconfirm
                onConfirm={async () => {
                  await deleteItemForever({ id: record?.id, type: 'SUBMODEL' });
                }}
                onCancel={e => e?.stopPropagation()}
                autoAdjustOverflow
                placement="topRight"
                title={() => (
                  <p>
                    Delete this <b>Submodel</b>{' '}
                    <span style={{ color: 'red' }}>Permanently</span> ?
                  </p>
                )}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              >
                <Button ghost={true} className="deleteButton">
                  <DeleteFilled />
                </Button>
              </Popconfirm>
            </div>
          )
        }
      ]}
      loading={recyclerLoading}
      dataSource={submodels}
      tableLayout="auto"
      rowKey="id"
      onChange={(pagination, _, sort) => {
        const { current = 1, pageSize = 10 } = pagination;
        getAllDeletedItems(search, pageSize, current, 'SUBMODEL');
      }}
      pagination={{
        disabled: recyclerLoading,
        total: total,
        pageSize: limit,
        current: offset,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }}
    />
  );
});

export default Submodel;
